import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { X, ChevronLeft } from "lucide-react";
import { SET_SELECTED_FILTERS } from "../../../redux/actions/types";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";

const Experience = ({ isOpen, onCloseAll, onClose, onApplyFilters }) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const selectedFilters = useSelector((store) => store?.hallOfFame?.selectedFilters);
  const [selectedExperiences, setSelectedExperiences] = useState(selectedFilters?.experience || []);

  const experienceLevels = [
    "0-1 years",
    "1-2 years",
    "2-5 years",
    "5-10 years",
    "10-15 years",
    "15+ years"
  ];

  useEffect(() => {
    setSelectedExperiences(selectedFilters?.experience || []);
  }, [selectedFilters]);

  useEffect(() => {
    if (isOpen) {
      setShowModal(true);
      document.body.style.overflow = "hidden";
    } else {
      setTimeout(() => setShowModal(false), 300);
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const toggleExperience = (experience) => {
    setSelectedExperiences((prev) =>
      prev.includes(experience)
        ? prev.filter((e) => e !== experience)
        : [...prev, experience]
    );
  };

  const handleApply = () => {
    Mixpanel.track(Constants.Mixpanel.RECRUITER_FILTER_DRAWER_APPLY_FILTERS_SUBMITTED);
    onClose();
    const newFilters = { ...selectedFilters, experience: selectedExperiences };
    dispatch({ type: SET_SELECTED_FILTERS, payload: newFilters });
    onApplyFilters(newFilters);
  };

  const handleClear = () => {
    Mixpanel.track(Constants.Mixpanel.RECRUITER_FILTER_DRAWER_CLEAR_FILTERS_CLICKED);
    setSelectedExperiences([]);
  };

  if (!showModal && !isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-end justify-center transition-all duration-300 md:items-center ${isOpen ? "visible" : "invisible"
        }`}
    >
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0"
          }`}
        onClick={onClose}
      />

      {/* Modal Container */}
      <div
        style={{
          backgroundImage: "linear-gradient(180deg, #0B2435 0%, #0E3653 100%)",
        }}
        className={`relative z-10 w-full max-h-[90vh] md:max-h-[85vh] overflow-hidden flex flex-col md:w-[450px] text-white rounded-t-3xl md:rounded-2xl p-6 shadow-xl transition-all duration-300 transform ${isOpen
          ? "translate-y-0 opacity-100 scale-100"
          : "translate-y-full md:translate-y-10 opacity-0 md:scale-95"
          }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <button
              onClick={onClose}
              className="flex items-center text-gray-300 hover:text-white transition-colors"
            >
              <ChevronLeft size={20} className="mr-1" />
              <h2 className="text-2xl font-bold text-white">Experience</h2>
            </button>
          </div>
          <button
            onClick={onCloseAll}
            className="p-1 rounded-full hover:bg-white/10 transition-colors"
          >
            <X size={24} className="text-gray-400 hover:text-white" />
          </button>
        </div>

        {/* Sub Header / Navigation */}
        {/* <div className="flex items-center mb-6 border-b border-gray-700/50 pb-2">
          <button
            onClick={onClose}
            className="flex items-center text-gray-300 hover:text-white transition-colors"
          >
            <ChevronLeft size={20} className="mr-1" />
            <span>Experience</span>
          </button>
        </div> */}

        {/* Experience Grid - Scrollable Area */}
        <div className="flex-1 overflow-y-auto min-h-0 mb-6 scrollbar-hide">
          <div className="grid grid-cols-2 gap-3">
            {experienceLevels.map((level, index) => {
              const isSelected = selectedExperiences.includes(level);
              return (
                <button
                  key={index}
                  onClick={() => toggleExperience(level)}
                  className={`px-4 py-4 rounded-xl border text-sm font-medium transition-all duration-200 flex items-center justify-center text-center h-16 ${isSelected
                    ? "bg-[#00C1FF] border-[#00C1FF] text-white"
                    : "bg-[#1A3855] border-[#1A3855] text-white hover:bg-[#234668]"
                    }`}
                >
                  {level}
                </button>
              );
            })}
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="flex gap-4 mt-auto pt-4">
          <button
            className="flex-1 bg-[#448B47] hover:bg-[#38753b] text-white font-semibold py-3 rounded-xl transition-colors"
            onClick={() => handleApply()}
          >
            Apply
          </button>
          <button
            onClick={handleClear}
            className="flex-1 bg-[#1A3855] hover:bg-[#234668] text-white font-semibold py-3 rounded-xl transition-colors"
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default Experience;
